var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCloseButtonIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 17,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 14.435,
  width: 20,
  height: 2,
  rx: 1,
  transform: "rotate(-45 .5 14.435)",
  fill: "#878E95"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 1.914,
  width: 20,
  height: 2,
  rx: 1,
  transform: "rotate(45 1.914 0)",
  fill: "#878E95"
})));
export default SvgCloseButtonIcon;